import {req} from '../api.ts';
import {h} from '../dom.ts';
import {commandId,PlayJournal,readPlayer,sessionRecovery} from './client.ts';

export function opponentControls(game:string,actor:string,opponent:string):HTMLElement {
  const root=h(`<details class="club-save"><summary>Player controls</summary>
    <p>Blocking prevents future pairings with this player. It does not end the current game.</p>
    <button class="btn ghost" data-block>Block future games</button><button class="btn ghost" data-unblock>Remove block</button>
    <form><h3>Report this player</h3><label class="field"><span>Reason</span><select name="reason"><option value="abuse">Abuse</option><option value="cheating">Cheating</option><option value="other">Other</option></select></label>
    <label class="field"><span>Details for the club operator (optional)</span><textarea name="detail" maxlength="500" rows="3"></textarea></label><button class="btn" type="submit">Send report</button></form>
    <p class="msg" role="status" aria-live="polite"></p></details>`);
  const message=root.querySelector<HTMLElement>('.msg')!;
  let busy=false;
  async function run(work:()=>Promise<void>) {
    if(busy)return;busy=true;root.querySelectorAll<HTMLButtonElement>('button').forEach(b=>b.disabled=true);
    try {await work();}catch(error){message.textContent=error instanceof Error?error.message:'Please retry.';sessionRecovery(root,error);}
    finally{busy=false;root.querySelectorAll<HTMLButtonElement>('button').forEach(b=>b.disabled=false);}
  }
  for(const [selector,blocked] of [['[data-block]',true],['[data-unblock]',false]] as const) {
    root.querySelector<HTMLButtonElement>(selector)!.onclick=()=>void run(async()=> {
      const player=await readPlayer();if(!player)throw new Error('Your browser session expired.');
      await req('POST','/api/play/blocks',{actor_id:player.id,player_id:opponent,blocked});
      message.textContent=blocked?'Future pairings with this player are blocked.':'Block removed.';
    });
  }
  const form=root.querySelector('form')!;
  form.onsubmit=event=> {
    event.preventDefault();void run(async()=> {
      const fields=new FormData(form);
      await new PlayJournal(actor,`report:${game}`).send('/api/play/reports',{actor_id:actor,command_id:commandId(),game_id:game,player_id:opponent,reason:fields.get('reason'),detail:fields.get('detail')}, () => {
        message.textContent='Report received by the club operator.';form.remove();
      });
    });
  };
  return root;
}

export async function renderReports(root:HTMLElement):Promise<void> {
  root.textContent='Loading reports…';
  try {
    const {reports}=await req<{reports:{id:string;reporter_id:string;subject_id:string;game_id:string|null;reason:string;detail:string;created_at:number}[]}>('GET','/api/play/reports/review');
    root.replaceChildren();
    const title=document.createElement('h2');title.textContent='Open player reports';root.append(title);
    if(!reports.length){const empty=document.createElement('p');empty.textContent='No open reports.';root.append(empty);}
    for(const report of reports) {
      const row=h('<article class="club-panel"><h3></h3><p data-players></p><p data-detail></p><button class="btn ghost" data-dismiss>Dismiss report</button><button class="btn" data-suspend>Suspend player</button><p class="msg" role="status"></p></article>');
      row.querySelector('h3')!.textContent=`${report.reason} · ${new Date(report.created_at*1000).toLocaleString()}`;
      row.querySelector('[data-players]')!.textContent=`Reporter ${report.reporter_id} · Player ${report.subject_id}${report.game_id?` · Game ${report.game_id}`:''}`;
      row.querySelector('[data-detail]')!.textContent=report.detail;
      for(const [selector,suspend] of [['[data-dismiss]',false],['[data-suspend]',true]] as const) {
        row.querySelector<HTMLButtonElement>(selector)!.onclick=async()=> {
          row.querySelectorAll<HTMLButtonElement>('button').forEach(b=>b.disabled=true);
          try{await req('POST',`/api/play/reports/${report.id}/resolve`,{suspend});row.remove();}
          catch(error){row.querySelector('.msg')!.textContent=error instanceof Error?error.message:'Please retry.';row.querySelectorAll<HTMLButtonElement>('button').forEach(b=>b.disabled=false);}
        };
      }
      root.append(row);
    }
  } catch(error){root.textContent=error instanceof Error?error.message:'Could not load reports.';}
}
